/**
 * Cross-fade animation between two icon states.
 *
 * Both icons remain in the DOM. The inactive icon defines layout size,
 * the active icon overlays via absolute positioning. Toggling isActive
 * cross-fades with scale + opacity + blur.
 */

import type { ReactNode } from "react";
import { mergeClasses } from "@coreai/fluentui-react";
import { useStyles } from "./dockToolbar.styles";

export interface IconCrossfadeProps {
  isActive: boolean;
  activeIcon: ReactNode;
  inactiveIcon: ReactNode;
}

export const IconCrossfade: React.FC<IconCrossfadeProps> = ({
  isActive,
  activeIcon,
  inactiveIcon,
}) => {
  const styles = useStyles();

  return (
    <span className={styles.iconCrossfade}>
      <span
        className={mergeClasses(
          styles.iconCrossfadeLayer,
          styles.iconCrossfadeOverlay,
          isActive ? styles.iconVisible : styles.iconHidden,
        )}
        aria-hidden="true"
      >
        {activeIcon}
      </span>
      <span
        className={mergeClasses(
          styles.iconCrossfadeLayer,
          isActive ? styles.iconHidden : styles.iconVisible,
        )}
        aria-hidden="true"
      >
        {inactiveIcon}
      </span>
    </span>
  );
};
